import { SiteDown } from './core/components/SiteDown';
import { getActiveNotifications } from './features/admin/notifications/notification-service';
import { currentTzMillis } from './features/admin/notifications/steps/utils';
import { useEffect, useRef, useState, ReactNode } from 'react';
import { useHistory } from 'react-router';
import { NotificationType } from '@ssar-app/domain';

interface DowntimeWrapperProps {
  children?: ReactNode;
}

export const DowntimeWrapper = (props: DowntimeWrapperProps) => {
  const { children } = props;
  const [showNotification, setShowNotification] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();

  const autoRefreshInterval = 30 * 1000;

  const setTimeoutId = useRef(0);

  const fetchMaintenanceEvent = (fromTimeout: boolean) => {
    if (!fromTimeout) {
      setIsLoading(true);
    }
    getActiveNotifications()
      .then((res) => {
        if (res.resultCode === 0) {
          const data = (res.data || []).filter(
            (notification) =>
              notification.type === NotificationType.MAINTENANCE &&
              currentTzMillis(notification.details.timeZone) >=
                notification.details.startTime &&
              notification.details.endTime >=
                currentTzMillis(notification.details.timeZone),
          );
          setShowNotification(data.length > 0);
          if (data.length > 0) {
            if (!localStorage.getItem('isSiteDown')) {
              localStorage.setItem('isSiteDown', '1');
              history.replace('/internal-login');
            }
          } else {
            localStorage.removeItem('isSiteDown');
          }
          setTimeoutId.current = setTimeout(
            () => fetchMaintenanceEvent(true),
            autoRefreshInterval,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
          ) as any;
        }
      })
      .catch(() => setShowNotification(false))
      .finally(() => {
        setIsLoading(false);
      });
  };
  useEffect(() => {
    fetchMaintenanceEvent(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    return () => {
      clearTimeout(setTimeoutId.current);
    };
  }, []);

  return <>{!isLoading && (showNotification ? <SiteDown /> : children)}</>;
};
